<template>
    <v-layout align-center justify-center row wrap>
        <v-flex xs8 sm5 class="option pa-3" v-bind:class="classStatus1" @click="select('1')">
            <span class="option-title">{{ option1 }}</span>
            <v-img
                    :src="option1_image"
                    contain
                    height="70"
            ></v-img>
            <v-radio-group v-model="value">
                <v-radio class="justify-center" value="1"></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex xs8 sm5 offset-sm2 class="option pa-3" v-bind:class="classStatus2" @click="select('2')">
            <span class="option-title">{{ option2 }}</span>
            <v-img
                    :src="option2_image"
                    contain
                    height="70"
            ></v-img>
            <v-radio-group v-model="value" class="justify-center">
                <v-radio class="justify-center" value="2"></v-radio>
            </v-radio-group>
        </v-flex>

    </v-layout>
</template>

<script>
    import EmptySpace from "../components/EmptySpace";

    export default {
        name: "ImageOptionSelector2",
        props: {
            option1: {
                type: String,
                default: "Option 1"
            },
            option1_image: {
                type: String,
                default: ""
            },
            option2: {
                type: String,
                default: "Option 2"
            },
            option2_image: {
                type: String,
                default: ""
            },
            value: {
                type: String
            }
        },
        data: vm => ({}),
        components: [
            EmptySpace
        ],
        computed: {
            classStatus1: function () {
                return {
                    'elevation-4': this.value == "1"
                }
            },
            classStatus2: function () {
                return {
                    'elevation-4': this.value == "2"
                }
            }
        },
        watch: {
            value() {
                this.$emit('input', this.value);
            }
        },
        methods: {
            select(option) {
                this.value = option;
            }
        }

    }
</script>

<style scoped less>

    .option {
        text-align: center;
        cursor: pointer;
        background-color: #f3f8f5;
        border: 1px solid #22753a;
        border-radius: 4px;
        margin-bottom: 20px;
    }

    .option .v-radio {
        margin-right: 0px;
    }

    .flex-center {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .option-title {
        font-weight: bold;
        color: #22753a;
        display: inline-block;
        margin-bottom: 15px;
        font-size: 0.85em;
    }

    .v-input--selection-controls__input {
        text-align: center;
        background-color: #0d47a1;
    }


</style>